"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledBubbleMessage = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var translations_1 = require("../utils/translations");
var DisabledBubbleMessage = /** @class */ (function (_super) {
    tslib_1.__extends(DisabledBubbleMessage, _super);
    function DisabledBubbleMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DisabledBubbleMessage.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children, intl = _a.intl;
        return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: className },
            children,
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: this.getBubbleClassNames(), alignPoints: [{ align: "cr cl" }] }, translations_1.getTranslation("properties.not_applicable", intl))));
    };
    DisabledBubbleMessage.prototype.getBubbleClassNames = function () {
        return classnames_1.default("bubble-primary", {
            invisible: !this.props.showDisabledMessage,
        });
    };
    return DisabledBubbleMessage;
}(react_1.default.PureComponent));
exports.DisabledBubbleMessage = DisabledBubbleMessage;
exports.default = react_intl_1.injectIntl(DisabledBubbleMessage);
//# sourceMappingURL=DisabledBubbleMessage.js.map